import { render, staticRenderFns } from "./make.vue?vue&type=template&id=6e6a057e&"
import script from "./make.vue?vue&type=script&lang=js&"
export * from "./make.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports